import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CustomPlaceholder } from '@yme/atoms/custom-placeholder';
import { useIsMount, useIsShowCustomPlaceholder } from '@yme/common/hooks';
import { IndentWrapper } from '@yme/components/Separator';
import { ProductCarousel } from '@yme/organisms/product-carousel';
import { getProducts } from '@yme/organisms/product-carousel/helpers';
import { getDaysToShowNew } from '@yme/selectors/index';
import { getProductCarouselParams } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { getRelatedUnits } from '../redux/selectors';
import { CARD_ITEM_SETTINGS } from './constants';
export const ExperienceRelatedUnits = ({ isRemoveBottomIndent, isInEditor, }) => {
    const [productData, setProductData] = useState([]);
    const productCarouselCommonParams = useSelector(getProductCarouselParams);
    const daysToShowNew = useSelector(getDaysToShowNew);
    const relatedUnits = useSelector(getRelatedUnits);
    const isMount = useIsMount();
    const { t } = useTranslation();
    const isShowCustomPlaceholder = useIsShowCustomPlaceholder();
    useEffect(() => {
        if (isMount) {
            return;
        }
        setProductData(getProducts({
            data: relatedUnits,
        }));
    }, [isMount, relatedUnits]);
    if (isInEditor && isShowCustomPlaceholder && !productData.length) {
        return React.createElement(CustomPlaceholder, { title: "Experience related units" });
    }
    if (!productData.length) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(ProductCarousel, { title: t('destinations_experienceRelatedUnits_header'), infoText: t('destinations_experienceRelatedUnits_info'), commonParams: productCarouselCommonParams, products: productData, daysToShowNew: daysToShowNew, carouselConfig: CARD_ITEM_SETTINGS })));
};
